// emojis.js — ARQUIVO GERADO (ferramentas/gerar_emojis.js). Não edite à mão.
//
// Todos os 1186 emojis de apresentação padrão que o Unicode do Node 22
// conhece, agrupados por assunto. Fica no repositório, e não numa biblioteca:
// as bibliotecas de seletor de emoji trazem dezenas de megabytes de imagens
// para desenhar o que a fonte do próprio sistema já desenha. Aqui é texto —
// 2 KB no total.
//
// O que NÃO está aqui: bandeiras (pares de indicadores regionais), tons de
// pele e sequências com juntor (família, profissões). Elas continuam
// possíveis pelo campo de colar do seletor, que aceita qualquer coisa que o
// teclado de emoji do aparelho produza.
const EMOJIS = [
  {
    "nome": "Rostos",
    "icone": "bi-emoji-smile",
    "faixas": [
      [
        128512,
        128591
      ],
      [
        129296,
        129327
      ],
      [
        129392,
        129402
      ],
      [
        129760,
        129775
      ]
    ],
    "itens": "😀😁😂😃😄😅😆😇😈😉😊😋😌😍😎😏😐😑😒😓😔😕😖😗😘😙😚😛😜😝😞😟😠😡😢😣😤😥😦😧😨😩😪😫😬😭😮😯😰😱😲😳😴😵😶😷😸😹😺😻😼😽😾😿🙀🙁🙂🙃🙄🙅🙆🙇🙈🙉🙊🙋🙌🙍🙎🙏🤐🤑🤒🤓🤔🤕🤖🤗🤘🤙🤚🤛🤜🤝🤞🤟🤠🤡🤢🤣🤤🤥🤦🤧🤨🤩🤪🤫🤬🤭🤮🤯🥰🥱🥲🥳🥴🥵🥶🥷🥸🥹🥺🫠🫡🫢🫣🫤🫥🫦🫧🫨🫩🫪🫯"
  },
  {
    "nome": "Pessoas",
    "icone": "bi-people",
    "faixas": [
      [
        128100,
        128135
      ],
      [
        129328,
        129342
      ],
      [
        129460,
        129471
      ],
      [
        129488,
        129503
      ],
      [
        129484,
        129487
      ],
      [
        129776,
        129791
      ]
    ],
    "itens": "👤👥👦👧👨👩👪👫👬👭👮👯👰👱👲👳👴👵👶👷👸👹👺👻👼👽👾👿💀💁💂💃💄💅💆💇🤰🤱🤲🤳🤴🤵🤶🤷🤸🤹🤺🤼🤽🤾🦴🦵🦶🦷🦸🦹🦺🦻🦼🦽🦾🦿🧐🧑🧒🧓🧔🧕🧖🧗🧘🧙🧚🧛🧜🧝🧞🧟🧌🧍🧎🧏🫰🫱🫲🫳🫴🫵🫶🫷🫸"
  },
  {
    "nome": "Bichos e natureza",
    "icone": "bi-flower1",
    "faixas": [
      [
        128000,
        128063
      ],
      [
        129408,
        129454
      ],
      [
        127792,
        127807
      ],
      [
        127744,
        127788
      ],
      [
        129373,
        129373
      ]
    ],
    "itens": "🐀🐁🐂🐃🐄🐅🐆🐇🐈🐉🐊🐋🐌🐍🐎🐏🐐🐑🐒🐓🐔🐕🐖🐗🐘🐙🐚🐛🐜🐝🐞🐟🐠🐡🐢🐣🐤🐥🐦🐧🐨🐩🐪🐫🐬🐭🐮🐯🐰🐱🐲🐳🐴🐵🐶🐷🐸🐹🐺🐻🐼🐽🐾🦀🦁🦂🦃🦄🦅🦆🦇🦈🦉🦊🦋🦌🦍🦎🦏🦐🦑🦒🦓🦔🦕🦖🦗🦘🦙🦚🦛🦜🦝🦞🦟🦠🦡🦢🦣🦤🦥🦦🦧🦨🦩🦪🦫🦬🦭🦮🌰🌱🌲🌳🌴🌵🌷🌸🌹🌺🌻🌼🌽🌾🌿🌀🌁🌂🌃🌄🌅🌆🌇🌈🌉🌊🌋🌌🌍🌎🌏🌐🌑🌒🌓🌔🌕🌖🌗🌘🌙🌚🌛🌜🌝🌞🌟🌠🥝"
  },
  {
    "nome": "Comida",
    "icone": "bi-cup-hot",
    "faixas": [
      [
        127789,
        127871
      ],
      [
        129344,
        129391
      ],
      [
        129472,
        129483
      ],
      [
        129744,
        129759
      ]
    ],
    "itens": "🌭🌮🌯🍀🍁🍂🍃🍄🍅🍆🍇🍈🍉🍊🍋🍌🍍🍎🍏🍐🍑🍒🍓🍔🍕🍖🍗🍘🍙🍚🍛🍜🍝🍞🍟🍠🍡🍢🍣🍤🍥🍦🍧🍨🍩🍪🍫🍬🍭🍮🍯🍰🍱🍲🍳🍴🍵🍶🍷🍸🍹🍺🍻🍼🍾🍿🥀🥁🥂🥃🥄🥅🥇🥈🥉🥊🥋🥌🥍🥎🥏🥐🥑🥒🥓🥔🥕🥖🥗🥘🥙🥚🥛🥜🥞🥟🥠🥡🥢🥣🥤🥥🥦🥧🥨🥩🥪🥫🥬🥭🥮🥯🧀🧁🧂🧃🧄🧅🧆🧇🧈🧉🧊🧋🫐🫑🫒🫓🫔🫕🫖🫗🫘🫙🫚🫛🫜🫟"
  },
  {
    "nome": "Viagem",
    "icone": "bi-airplane",
    "faixas": [
      [
        128640,
        128767
      ],
      [
        127968,
        127984
      ],
      [
        128506,
        128511
      ],
      [
        127757,
        127760
      ]
    ],
    "itens": "🚀🚁🚂🚃🚄🚅🚆🚇🚈🚉🚊🚋🚌🚍🚎🚏🚐🚑🚒🚓🚔🚕🚖🚗🚘🚙🚚🚛🚜🚝🚞🚟🚠🚡🚢🚣🚤🚥🚦🚧🚨🚩🚪🚫🚬🚭🚮🚯🚰🚱🚲🚳🚴🚵🚶🚷🚸🚹🚺🚻🚼🚽🚾🚿🛀🛁🛂🛃🛄🛅🛌🛐🛑🛒🛕🛖🛗🛘🛜🛝🛞🛟🛫🛬🛴🛵🛶🛷🛸🛹🛺🛻🛼🏠🏡🏢🏣🏤🏥🏦🏧🏨🏩🏪🏫🏬🏭🏮🏯🏰🗻🗼🗽🗾🗿"
  },
  {
    "nome": "Atividades",
    "icone": "bi-trophy",
    "faixas": [
      [
        127904,
        127967
      ],
      [
        9917,
        9977
      ],
      [
        129337,
        129343
      ],
      [
        129664,
        129695
      ]
    ],
    "itens": "🎠🎡🎢🎣🎤🎥🎦🎧🎨🎩🎪🎫🎬🎭🎮🎯🎰🎱🎲🎳🎴🎵🎶🎷🎸🎹🎺🎻🎼🎽🎾🎿🏀🏁🏂🏃🏄🏅🏆🏇🏈🏉🏊🏏🏐🏑🏒🏓⚽⚾⛄⛅⛎⛔⛪⛲⛳⛵🤿🪀🪁🪂🪃🪄🪅🪆🪇🪈🪉🪊🪎🪏🪐🪑🪒🪓🪔🪕🪖🪗🪘🪙🪚🪛🪜🪝🪞🪟"
  },
  {
    "nome": "Objetos",
    "icone": "bi-lightbulb",
    "faixas": [
      [
        128160,
        128255
      ],
      [
        128187,
        128187
      ],
      [
        128736,
        128752
      ],
      [
        129520,
        129535
      ],
      [
        129696,
        129711
      ],
      [
        127872,
        127904
      ]
    ],
    "itens": "💠💡💢💣💤💥💦💧💨💩💪💫💬💭💮💯💰💱💲💳💴💵💶💷💸💹💺💻💼💽💾💿📀📁📂📃📄📅📆📇📈📉📊📋📌📍📎📏📐📑📒📓📔📕📖📗📘📙📚📛📜📝📞📟📠📡📢📣📤📥📦📧📨📩📪📫📬📭📮📯📰📱📲📳📴📵📶📷📸📹📺📻📼📿🧰🧱🧲🧳🧴🧵🧶🧷🧸🧹🧺🧻🧼🧽🧾🧿🪠🪡🪢🪣🪤🪥🪦🪧🪨🪩🪪🪫🪬🪭🪮🪯🎀🎁🎂🎃🎄🎅🎆🎇🎈🎉🎊🎋🎌🎍🎎🎏🎐🎑🎒🎓"
  },
  {
    "nome": "Símbolos",
    "icone": "bi-heart",
    "faixas": [
      [
        128256,
        128317
      ],
      [
        9728,
        10175
      ],
      [
        11008,
        11263
      ],
      [
        127376,
        127386
      ],
      [
        126980,
        127183
      ],
      [
        127344,
        127375
      ]
    ],
    "itens": "🔀🔁🔂🔃🔄🔅🔆🔇🔈🔉🔊🔋🔌🔍🔎🔏🔐🔑🔒🔓🔔🔕🔖🔗🔘🔙🔚🔛🔜🔝🔞🔟🔠🔡🔢🔣🔤🔥🔦🔧🔨🔩🔪🔫🔬🔭🔮🔯🔰🔱🔲🔳🔴🔵🔶🔷🔸🔹🔺🔻🔼🔽☔☕♈♉♊♋♌♍♎♏♐♑♒♓♿⚓⚡⚪⚫⛺⛽✅✊✋✨❌❎❓❔❕❗➕➖➗➰➿⬛⬜⭐⭕🆑🆒🆓🆔🆕🆖🆗🆘🆙🆚🀄🃏🆎"
  },
  {
    "nome": "Outros",
    "icone": "bi-three-dots",
    "itens": "⌚⌛⏩⏪⏫⏬⏰⏳🈁🈚🈯🈲🈳🈴🈵🈶🈸🈹🈺🉐🉑🏴🏸🏹🏺👀👂👃👄👅👆👇👈👉👊👋👌👍👎👏👐👑👒👓👔👕👖👗👘👙👚👛👜👝👞👟👠👡👢👣💈💉💊💋💌💍💎💏💐💑💒💓💔💕💖💗💘💙💚💛💜💝💞💟🕋🕌🕍🕎🕐🕑🕒🕓🕔🕕🕖🕗🕘🕙🕚🕛🕜🕝🕞🕟🕠🕡🕢🕣🕤🕥🕦🕧🕺🖕🖖🖤🟠🟡🟢🟣🟤🟥🟦🟧🟨🟩🟪🟫🟰🤌🤍🤎🤏🥻🥼🥽🥾🥿🦯🦰🦱🦲🦳🧠🧡🧢🧣🧤🧥🧦🧧🧨🧩🧪🧫🧬🧭🧮🧯🩰🩱🩲🩳🩴🩵🩶🩷🩸🩹🩺🩻🩼🪰🪱🪲🪳🪴🪵🪶🪷🪸🪹🪺🪻🪼🪽🪾🪿🫀🫁🫂🫃🫄🫅🫆🫈🫍🫎🫏"
  }
];

export default EMOJIS;
